// @flow

import type {UrlGenerator} from '../../../server/services';

export const IMAGE_PREFIX = 'images/';
// The Markdoc images are stored in docs/content, which gets outputted
// to the webpack manifest as content/images/**
export const imageSrcToPublicUrl = (
  src: string,
  urlGenerator: UrlGenerator,
  locale?: ?string, // TODO: Think about adding locale to all other places that imageSrcToPublicUrl is called.
): string => {
  // We explictly check if it is a string because the src comes from a Markdoc
  // attribute, so we perform this check in case the attribute was incorrectly cast
  // to a string and passed to this function
  const shouldTransformSrc =
    typeof src === 'string' && src[0] !== '/' && !src.startsWith('http://');

  if (!shouldTransformSrc) {
    return src;
  }

  if (locale && locale !== 'en-US') {
    const localizedSrc = `${src.slice(
      0,
      IMAGE_PREFIX.length,
    )}intl/${locale}/${src.slice(IMAGE_PREFIX.length)}`;
    // This is the image we _think_ we might have based on locale
    const generatedLocalizedSrc = urlGenerator.generateFromPath(
      `content/${localizedSrc}`,
    );
    if (generatedLocalizedSrc) {
      return generatedLocalizedSrc;
    }
  }

  // If we cannot find localized image, proceed with the unlocalized source, which by default is an English image
  const generatedSrc = urlGenerator.generateFromPath(`content/${src}`);
  if (!generatedSrc) {
    // TODO(matv): Consider using Sentry here - right now this runs server side so we do
    // not have a Sentry client.
    // eslint-disable-next-line no-console
    console.error('Could not find', src, 'in webpack build');
    return src;
  }

  return generatedSrc;
};
